import React from 'react'
import cx from 'classnames'
import { Link } from 'gatsby'
import * as styles from '../../styles/components/desktop-nav.module.scss'

interface DesktopNavBarProps {
    links: Queries.NamedLinks[]
    title: string
    scrolledToTop: boolean
    className?: string
}

const DesktopNavBar = (props: DesktopNavBarProps) => {
    const { links, title, scrolledToTop, className } = props

    return (
        <nav className={cx(styles.container, { [styles.containerTop]: scrolledToTop }, className)}>
            <div className={styles.brandContainer}>
                <Link to="/">
                    <span
                        className={cx(styles.linkText, { [styles.linkTextTop]: scrolledToTop })}>
                        {title}
                    </span>
                </Link>
            </div>
            <div className={styles.navMenu}>
                {links?.map((link) =>
                    <Link to={link.url} className={styles.navLink} key={link.name}>
                        <span
                            className={cx(styles.linkText, { [styles.linkTextTop]: scrolledToTop })}
                        >
                            {link.name}
                        </span>
                    </Link>,
                )}
            </div>
        </nav>
    )
}

export default DesktopNavBar
